import { Component } from 'react';

// Red de seguridad para pantallas críticas (TPV, escáner). Sin esto, un error de
// render deja la pantalla EN BLANCO y la única salida es cerrar y volver a entrar —
// el patrón que se vio en la caja el viernes 24.
// Con esto: se muestra qué pasó, se ofrece reintentar SIN perder la sesión, y el
// error queda en la caja negra.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(err) {
    return { err };
  }

  componentDidCatch(err, info) {
    // El reporte va en try/catch: si la caja negra falla, no puede tapar el error
    // original ni romper esta pantalla otra vez.
    try {
      this.props.onError?.(err, info);
    } catch { /* noop */ }
  }

  render() {
    if (!this.state.err) return this.props.children;
    const msg = String(this.state.err?.message || this.state.err || 'error');
    return (
      <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ maxWidth: 460, width: '100%', textAlign: 'center' }}>
          <div style={{ fontSize: 52, lineHeight: 1, marginBottom: 14 }}>⚠</div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, color: '#fff', textTransform: 'uppercase' }}>
            {this.props.title || 'Se cortó la pantalla'}
          </div>
          <div style={{ fontSize: 13.5, color: 'var(--ink-700)', marginTop: 12, lineHeight: 1.5 }}>
            {this.props.hint || 'Tocá "Reintentar" para volver a cargar esta pantalla. No se perdió nada de lo que ya estaba guardado.'}
          </div>
          <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 14, fontFamily: 'monospace', wordBreak: 'break-word' }}>{msg.slice(0, 160)}</div>
          <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
            {/* Reintentar NO recarga la página: vuelve a montar el árbol y conserva la
                sesión de la caja (y su cola offline). */}
            <button className="lb-btn lb-btn--primary lb-btn--block" onClick={() => this.setState({ err: null })}>Reintentar</button>
            <button className="lb-btn lb-btn--ghost lb-btn--block" onClick={() => window.location.reload()}>Recargar todo</button>
          </div>
        </div>
      </div>
    );
  }
}
